import { client } from '@api/client';
import { URL } from '@api/urls';

import {
	IAlarmAcknowledgedByStaticDTO,
	IAlarmClearedByStaticDTO,
	IAlarmMiddlewareDTO,
} from '@interfaces/alarms/dto/alarmsDTO';
import { TIdName, TNameTitle } from '@interfaces/common/common';

const {
	alarmManagementStaticOran,
	alarmManagementOranRoles,
	alarmManagementStaticOranMiddlewares,
	alarmManagementStaticOranNetworkElements,
	alarmManagementStaticOranClearedBy,
	alarmManagementStaticOranAcknowledgedBy,
} = URL;

export const getAlarmOranAlarmIds = (): Promise<Array<TNameTitle>> => {
	return client.get(`${alarmManagementStaticOran}/alarm-ids`);
};

export const getAlarmOranApplicabilities = (): Promise<Array<TNameTitle>> => {
	return client.get(`${alarmManagementStaticOran}/applicabilities`);
};

export const getAlarmOranGroups = (): Promise<Array<TNameTitle>> => {
	return client.get(`${alarmManagementStaticOran}/groups`);
};

export const getAlarmOranModuleNames = (): Promise<Array<TNameTitle>> => {
	return client.get(`${alarmManagementStaticOran}/module-names`);
};

export const getAlarmOranSeverities = (): Promise<Array<TNameTitle>> => {
	return client.get(`${alarmManagementStaticOran}/severities`);
};

export const getAlarmOranStatuses = (): Promise<Array<TNameTitle>> => {
	return client.get(`${alarmManagementStaticOran}/statuses`);
};

export const getAlarmOranEnableStatuses = (): Promise<Array<TNameTitle>> => {
	return client.get(`${alarmManagementStaticOran}/enable-statuses`);
};

export const getOranUserGroupsForAlarms = (): Promise<Array<TNameTitle>> => {
	return client.get(alarmManagementOranRoles);
};

export const getOranMiddlewaresForAlarms = (): Promise<Array<IAlarmMiddlewareDTO>> => {
	return client.get(alarmManagementStaticOranMiddlewares);
};

export const getOranNetworkElementsForAlarms = (): Promise<Array<TIdName>> => {
	return client.get(alarmManagementStaticOranNetworkElements);
};

export const getOranClearedBy = (): Promise<Array<IAlarmClearedByStaticDTO>> => {
	return client.get(alarmManagementStaticOranClearedBy);
};

export const getOranAcknowledgedBy = (): Promise<Array<IAlarmAcknowledgedByStaticDTO>> => {
	return client.get(alarmManagementStaticOranAcknowledgedBy);
};
